import React from 'react';
import {Form, Icon, Input, Radio, Select} from 'antd';
const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>Consent Process - WITHDRAWAL CONSENT FORM</h4>

          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_withdraw ?
          <div dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_withdraw_content}}/> :
          <div>
            <h4 align="center">INFORMATION AND CONSENT FORM</h4>
            <h4 align="center">Withdrawal Consent Form</h4>
            <h4>TITLE:&nbsp;&nbsp;&nbsp; Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research
              Alberta Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)</h4>
            <p><b>Principal Investigator:</b> Dr. Brian Buck</p>
            <p><b>Co-Investigators:</b> Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr.
              Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali
              Nomani</p>

            <p>You previously agreed to participate in this research study, but now have told us that you would like to
              withdraw your consent to participate. As stated in the original consent you signed, you are free to
              withdraw from this research, without giving a reason, and this will in no way affect the care that you are
              entitled to receive at this Institution. You do not need to sign this form to withdraw from this
              study.</p>

            <p>The purpose of this form is to see if you would agree to continue to attend follow-up visits and/or to
              allow information about you to be collected for the study. If this is ok with you, please check the boxes
              below to indicate your decision:</p>

          </div>
        }

        {(props.consentMethodType !== 'WithdrawConsentEmail' || props.token) && <Form.Item>
          {props.form.getFieldDecorator('wcf_option_1', {
            rules: [{
              required: true,
              message: 'Please select consent option below:'
            }],
          })(
            <Radio.Group>
              <Radio value="true">I agree to allow the study doctor to contact me at regular intervals to collect
                study-related information about how I am doing.</Radio>
              <Radio value="false">I will not be contacted by the study doctor, but I agree to allow the study doctor to
                collect study-related information about me and my health from medical records.</Radio>
            </Radio.Group>
          )}
        </Form.Item>}

        <p>If you have questions or concerns about your rights as a study participant including your right to freely
          withdraw from this study, you may contact the Research Ethics Office, at 780-492-2615.</p>

        <Form.Item>
          <div className='form-label'>Participant's Name</div>
          {props.form.getFieldDecorator('wcf_participant_name', {
            initialValue: props.wcf_participant_name || props.pcf_research_subject_name,
            rules: [{
              required: true,
              message: 'Please enter the Participant\'s name'
            }],
          })(
            <Input
              prefix={<Icon type="user" style={{color: '#eee'}}/>}
              placeholder="Participant name"
              autoFocus
            />
          )}
        </Form.Item>

        {props.consentMethodType === 'WithdrawConsentEmail' && <Form.Item>
          {props.form.getFieldDecorator('wcf_participant_email', {
            initialValue: props.wcf_participant_email,
            rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
          })(
            <Input disabled={props.token} placeholder="Participant Email"/>
          )}
        </Form.Item>}

        <Form.Item>
          <div className='form-label'>Person obtaining consent</div>
          {props.form.getFieldDecorator('wcf_person_obtaining_consent_name', {
            initialValue: props.wcf_person_obtaining_consent_name,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Input
              disabled={props.token}
              prefix={<Icon type="user" style={{color: '#eee'}}/>}
              placeholder="Person obtaining consent name"
              autoFocus
            />
          )}
        </Form.Item>

        {(props.consentMethodType !== 'WithdrawConsentEmail' || props.token) && <Form.Item>
          <label>
            <div className='form-label'>Do you consent to the terms described above?</div>
            {props.form.getFieldDecorator('consent_provided', {
              rules: [{
                required: true,
                message: 'Do you consent to the terms described above?'
              }],
            })(
              <Select>
                <Option value="yes">Yes</Option>
                <Option value="">No</Option>
              </Select>
            )}
          </label>
        </Form.Item>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLethbridge/Step3aWithdrawal.js